module.exports = __webpack_public_path__ + "static/media/BeVietnam-SemiBold.2c95a09f.ttf";